export default {"src":"/_next/static/media/check--white.51a9b3e3.svg","height":13,"width":12};